import { render, staticRenderFns } from "./CommonDiagramCardNuxt.vue?vue&type=template&id=433e5132&"
import script from "./CommonDiagramCardNuxt.vue?vue&type=script&lang=ts&"
export * from "./CommonDiagramCardNuxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports